module.exports = __webpack_public_path__ + "static/media/minus.d5b45bde.svg";